import { PropertySavedStatechartStore } from 'common/module/property/saved/statechart/store';
import { StatechartStoreFactory } from 'common/module/statechart/store.factory';
import { PropertySavedStoreService } from 'common/service/property-saved-store/service';
import { UserAuthenticationService } from 'common/service/user-authentication/service';

export function PropertySavedStatechartStoreFactory(): PropertySavedStatechartStore {
  return new PropertySavedStatechartStore(
    StatechartStoreFactory(),
    PropertySavedStoreService(),
    UserAuthenticationService()
  );
}
